module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAABVQTFRF+PjISDiQcDj4gHhwuKD4+Pj4////wpHZ6wAAAAF0Uk5TAEDm2GYAAABtSURBVBjTZY7RDcJQCEUxcYDqBlJZ4BL+TeME3tz9V2nosx9PTwKBEyDY9T3xss0nnuY/WAiiC/FxgQGLJKu+SQULkFEg18IpxLZqoTHBUK+0HeK4EadQHnUxlSzYmsgR3hn/j93n/mGX28SyAxYrLCxsWZ7+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Dragon.png
// module id = 159
// module chunks = 0